import { ApiError } from '@ottd/api';
import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';

/**
 * Maps a caught error onto a react-hook-form. Laravel/Fortify validation
 * failures (422) carry `{ errors: { field: [msg] } }`; those land on the
 * matching fields. Anything else (bad credentials with no field, 500, network)
 * is handed to `onGeneric` for a toast. Returns nothing - callers decide UX.
 */
export function applyApiErrors<TFieldValues extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<TFieldValues>,
  onGeneric: (message: string) => void,
): void {
  if (error instanceof ApiError) {
    const fieldErrors = error.validationErrors;
    const entries = Object.entries(fieldErrors);
    if (entries.length > 0) {
      for (const [field, messages] of entries) {
        const message = messages[0];
        if (message) {
          setError(field as Path<TFieldValues>, { type: 'server', message });
        }
      }
      return;
    }
    onGeneric(error.message);
    return;
  }
  onGeneric(error instanceof Error ? error.message : 'Something went wrong. Please try again.');
}
